const trackingGaugeColors = {
  VeryLow: '#FF0606',
  TooLow: '#FFA400',
  Good: '#1ED930',
  High: '#FFA400',
  VeryHigh: '#FF0606',
};

export const getTrackingGaugeDataFromStats = (rangePercentages: {
  [key: string]: number;
}) => {
  const data: any = [];
  const rangePercentagesKeys = Object.keys(rangePercentages);
  const rangePercentagesValues = Object.values(rangePercentages);
  const nonAccumulativePercentages = rangePercentagesValues.map(
    (value, index) => {
      if (!index) {
        return value;
      }
      return value - rangePercentagesValues[index - 1];
    },
  );
  const rotations = rangePercentagesValues.map((_, index) => {
    if (!index) {
      return 0;
    }
    return rangePercentagesValues[index - 1];
  });
  for (let i = 0; i < rangePercentagesKeys.length; i++) {
    data.push({
      color: trackingGaugeColors[rangePercentagesKeys[i]],
      rotation: rotations[i],
      percent: nonAccumulativePercentages[i],
    });
  }
  [data[data.length - 1], data[data.length - 2]] = [data[data.length - 2], data[data.length - 1]];
  return data;
};
